import Link from "next/link";
import { useTranslation } from "next-i18next";
import React, { useEffect, useState } from "react";

import { NoSsr } from "@mui/material";
import { Box } from "@mui/system";

import CookieBanner from "@components/CookieBanner/CookieBanner";
import { useMediaQueryBreakpoint } from "@hooks/useMediaQueryBreakpoint";

import { DesktopMenu } from "./DesktopMenu";
import { MenuContainer, TextLogoStyled } from "./Menu.styled";
import { MobileMenu } from "./MobileMenu";

interface MenuProps {
  fixed?: boolean;
}

export const Menu = ({ fixed }: MenuProps) => {
  const { isTablet } = useMediaQueryBreakpoint();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [mobileMenuOpened, setMobileMenuOpened] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    setScrollPosition(window.scrollY);

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const pageNotOnTop = scrollPosition !== 0;
  const applyBackgroundColor = isTablet && pageNotOnTop;
  const applyBackdropFilter = isTablet
    ? pageNotOnTop
    : pageNotOnTop && !mobileMenuOpened;

  return (
    <>
      <MenuContainer
        fixed={fixed}
        pageNotOnTop={pageNotOnTop}
        applyBackdropFilter={applyBackdropFilter}
        applyBackgroundColor={applyBackgroundColor}
      >
        <Link href={"/"} passHref title={t("menu.home")}>
          <Box
            sx={{
              ":hover": {
                cursor: "pointer",
              },
            }}
          >
            <TextLogoStyled alt={t("menu.home")} />
          </Box>
        </Link>

        {isTablet && <DesktopMenu />}

        {!isTablet && (
          <MobileMenu
            opened={mobileMenuOpened}
            setOpened={setMobileMenuOpened}
          />
        )}
      </MenuContainer>

      <NoSsr>
        <CookieBanner />
      </NoSsr>
    </>
  );
};
